import React from 'react'
import BannerSection from './section/banner'
import Institutions from './section/institutions'
import Topcourses from './section/top-courses'
import Featuredcourse from './section/featured-course'
import Faq from './section/faq'
// import Testimonials from './section/testimonials'
import Footer from '../../../core/common/footer/footer'
import Why from './section/why'
import CoorporateCampus from './section/coorporate-campus'
import CourseFacts from './section/course-facts'
import CBTFacts from './section/cbt-facts'
// import Footer from "./footer";

const HomeOne = () => {
  return (
    <div>
      <BannerSection />
      <Institutions />
      <Why />
      <CoorporateCampus />
      {/* <Trust /> */}
      <Featuredcourse
        type="Live_Teaching"
        title="Rekomendasi Kelas Live Teaching!"
        subtitle=""
        limit={6}
      />
      <CourseFacts />
      <Featuredcourse
        type="Course"
        title="Video E-Course Terbaru!"
        subtitle="Belajar Apa Saja Sesuai Kompetensi Yang Kamu Inginkan!"
        limit={6}
      />
      <CBTFacts />
      <Featuredcourse
        type="CBT"
        title="Pilihan Uji Kompetensi yang Bisa Kamu Kerjakan!"
        subtitle="Belajar Apa Saja Sesuai Kompetensi Yang Kamu Inginkan!"
        limit={6}
      />
      <Topcourses />
      {/* <Clinet /> */}
      {/* <Howitworks /> */}
      {/* <Featureinstructor /> */}
      {/* <Testimonials /> */}
      <Faq />
      {/* <Latestblog /> */}
      <Footer />
    </div>
  )
}

export default HomeOne
